<template>
    <rkm-content>
        <rkm-content-header :title="$route.meta.title">
            <template v-slot:actions>
                <rkm-button
                    :disabled="loading"
                    @click="handleExit"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="authorize('administracao-permissao-acesso-update')"
                    :disabled="loading"
                    @click="$refs.Form.save()"
                    color="success"
                >
                    Salvar
                </rkm-button>
            </template>
        </rkm-content-header>

        <rkm-content-body>
            <rkm-container>
                <Form
                    :id="id"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-container>
        </rkm-content-body>
    </rkm-content>
</template>

<script>
// Components.
import Form from '@/components/administracao/permissao-acesso/Form'

// Mixins.
import {authorization, notification} from '@/mixins'

// Vuex.
import {mapGetters} from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('administracao-permissao-acesso-form')
        },
    },
    methods: {
        handleSave() {
            this.showSuccessNotification()
            this.handleExit(false)
        },
        handleExit(notification) {
            this.$router.push({name: 'administracao-permissao-acesso-index', params: {notification: notification}})
        },
    },
    mixins: [authorization, notification],
    props: {
        id: {type: Number, required: true},
    },
}
</script>